import React from 'react';
import { Paintbrush } from 'lucide-react';
import { Heading } from '../layout';
import PaintProductsTable3 from './PaintProductsTable3';

const PaintProductsWorkspace = ({ isDarkMode = false }) => {
  return (
    <div>
      <Heading level={2} isDarkMode={isDarkMode}>
        <Paintbrush size={22} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
        Productos de pintura T-COAT
      </Heading>
      <PaintProductsTable3 isDarkMode={isDarkMode} />
    </div>
  );
};

export default PaintProductsWorkspace;
